import React from 'react';
import { Nav } from '../../components/nav';
import { useAuth } from '../../navigation/AuthProvider';
import "../css/Business.css";

export const Business = () => {
    const { company, timeSchemas, employees } = useAuth();

    const admins =
    employees
        ?.filter(e => ["admin", "super-admin"].includes(e.role))
        .sort((a, b) => {
        if (a.role === "super-admin" && b.role !== "super-admin") return -1;
        if (b.role === "super-admin" && a.role !== "super-admin") return 1;
        return 0; // keep original order otherwise
        }) || [];

    return (
        <div className="business-page">
            <Nav />

            <div className="business-header">
                <h1 className="business-main-title">Företagsöversikt</h1>
                <p className="business-subtitle">Här hittar du information om företaget, tidsscheman och administratörer.</p>
            </div>

            <div className="business-grid">
                {/* Företagsinfo */}
                <div className="business-card">
                    <h2>🧾 Företagsinformation</h2>
                    <p><strong>Namn:</strong> {company?.name}</p>
                    <p><strong>Registreringsdatum:</strong> {new Date(company?.createdAt).toLocaleDateString()}</p>
                </div>

                {/* Tidsscheman */}
                <div className="business-card">
                    <h2>⏱ Tidsscheman</h2>
                    {timeSchemas?.length > 0 ? (
                        <ul className="business-list">
                            {timeSchemas.map((schema) => (
                                <li key={schema.id}>📄 {schema.name}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="empty-text">Inga tidscheman har lagts till ännu.</p>
                    )}
                </div>

                {/* Admins */}
                <div className="business-card">
                    <h2>👥 Administratörer</h2>
                    {admins.length > 0 ? (
                        <ul className="business-list">
                            {admins.map((admin) => (
                                <li key={admin.id}>
                                    {admin.name} <span className="role-badge">{admin.role}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="empty-text">Inga administratörer är registrerade.</p>
                    )}
                </div>

                {/* Kontakt */}
           <div className="business-card">
                <h2>📞 Kontakt & Support</h2>
                <p>📧 <strong>E-post:</strong> company@timesmart.se</p>
                <p>
                    📱 <strong>Telefon:</strong><br/>
                    Hugo Nord<br/>
                    073-433 58 16
                </p>
                <p><strong>Öppettider support:</strong><br/>
                Mån–Fre: 10:00–17:00<br/>
                Lör–Sön: Stängt
                </p>
            </div>

            </div>
        </div>
    );
};
